<form [formGroup]="textForm" class="my-3">
  <quill-editor
    class="quill-editor"
    [placeholder]="''"
    formControlName="editor"
    [modules]="quillConfiguration"
    (onContentChanged)="onContentChanged($event)"></quill-editor>
</form>
